import domReady from '@wordpress/dom-ready';
import $ from 'jquery';

domReady(() => {
	const accordions = $('.faq-accordion .faq-question');

	accordions.each(function () {
		const button = $(this);
		const answer = button.next('.faq-answer');

		button.on('click', function () {
			const isExpanded = button.attr('aria-expanded') === 'true';

			button.attr('aria-expanded', String(!isExpanded));
			answer.attr('hidden', isExpanded);
		});
	});
});
